import {Injector} from '@angular/core';

/**
 * A injector for service. Use to inject the private service class into abstract service.
 */
export class ServiceLocator {
  static injector: Injector = null;
}



// WEBPACK FOOTER //
// ./src/app/service-locator.ts